var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.4,
    height: 54.397,
    viewBox: "0 0 54.4 54.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50132",
    "data-name": "Group 50132",
    transform: "translate(8739.668 -15124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93927",
    "data-name": "Path 93927",
    d: "M38.253,6.886a2.721,2.721,0,0,0-5.442,0v5.442h-13.6A10.88,10.88,0,0,0,8.332,23.206v8.16A10.881,10.881,0,0,0,19.213,42.246H51.852A10.881,10.881,0,0,0,62.732,31.366v-8.16A10.88,10.88,0,0,0,51.852,12.328h-13.6Zm19.038,16.32a5.439,5.439,0,0,0-5.439-5.439H19.213a5.439,5.439,0,0,0-5.439,5.439v8.16a5.44,5.44,0,0,0,5.439,5.442H51.852a5.44,5.44,0,0,0,5.439-5.442Zm-31.278,8.16a4.08,4.08,0,1,0-4.08-4.08A4.08,4.08,0,0,0,26.013,31.366Zm19.038,0a4.08,4.08,0,1,0-4.08-4.08A4.079,4.079,0,0,0,45.051,31.366ZM21.933,55.845a2.717,2.717,0,0,1,2.718-2.718H46.413a2.72,2.72,0,0,1,0,5.439H24.652A2.72,2.72,0,0,1,21.933,55.845ZM16.492,44.967a2.72,2.72,0,0,0,0,5.439H54.573a2.72,2.72,0,0,0,0-5.439Z",
    transform: "translate(-8748 15119.832)",
    fill: "#0c66e4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.d39e852079e5ae985451d23a560b4d0e.svg";
export { ForwardRef as ReactComponent };